import { createFileRoute } from '@tanstack/react-router';
import { PrestationParticipationPage } from '@/features/prestation-participations/components/PrestationParticipationPage';

export const Route = createFileRoute('/$commiteeSlug/prestation-participations/{-$id}')({
  component: PrestationParticipationPage,
});
